import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { Dashboard, Finding, FindingDetail, FindingsPage, FindingsQuery, VulnerabilityDetail } from '@ametica/shared';
import { api } from './client';
import { SITES_KEY } from './sites';
import { toApiQuery } from '../features/findings/filters';

export const DASHBOARD_KEY = ['dashboard'] as const;
export const FINDINGS_KEY = ['findings'] as const;

/** Nálezy jednej stránky — otvorené najprv, podľa závažnosti. */
export function useSiteFindings(id: string) {
  return useQuery({ queryKey: [...SITES_KEY, id, 'findings'], queryFn: () => api<Finding[]>(`/sites/${id}/findings`) });
}

/** Prehľad. Obnovuje sa každú minútu — sken aj sync bežia na pozadí (cron), nie len z tohto prehliadača. */
export function useDashboard() {
  return useQuery({ queryKey: DASHBOARD_KEY, queryFn: () => api<Dashboard>('/dashboard'), refetchInterval: 60_000 });
}

/**
 * Tabuľka naprieč stránkami. Filter, radenie aj stránkovanie robí backend;
 * pri zmene filtra ostanú staré riadky, kým neprídu nové (tabuľka nebliká).
 */
export function useFindingsPage(query: FindingsQuery) {
  const qs = toApiQuery(query);
  return useQuery({
    queryKey: [...FINDINGS_KEY, 'page', qs],
    queryFn: () => api<FindingsPage>(`/findings${qs}`),
    placeholderData: keepPreviousData,
  });
}

/** Odkaz na CSV export toho istého filtrovaného pohľadu (cookie relácie ide s ním). */
export function findingsCsvHref(query: FindingsQuery): string {
  return `/api/findings.csv${toApiQuery(query)}`;
}

export function useFindingDetail(id: string) {
  return useQuery({ queryKey: [...FINDINGS_KEY, id], queryFn: () => api<FindingDetail>(`/findings/${id}`), enabled: id !== '' });
}

export function useVulnerability(id: string) {
  return useQuery({ queryKey: ['vulnerabilities', id], queryFn: () => api<VulnerabilityDetail>(`/vulnerabilities/${id}`), enabled: id !== '' });
}
